import { useMutation } from 'react-query';
import { useApiPost } from 'src/api';
import { useBuildVars } from 'src/config';

export type SplitAndRemoveUpdateQuoteRequest = {
  dealId: string;
  magicKey: string;
  operations?: ['REMOVE_PRODUCTS'];
  quoteId?: string;
  splitQuantity?: number;
  uniqueId?: string;
};
export type SplitAndRemoveUpdateQuoteResponse = {
  errorCode: string | null;
  message: string;
  severity: string;
  statusCode: number;
};
export function useSplitAndRemoveUpdateQuote() {
  const buildVars = useBuildVars();
  const apiPost = useApiPost<SplitAndRemoveUpdateQuoteResponse>({
    host: buildVars.VP_API_BASE,
  });
  return useMutation((request: SplitAndRemoveUpdateQuoteRequest) =>
    apiPost(
      `/system.webapi.gds/api/v1/gdsCoreApiExternalApi/updatequote`,
      request
    )
  );
}

export type ReAcquireDealsParams = {
  CompanyCode: string;
  CountryCode: string;
  Dealid: string;
  HeaderId: string;
  VendorName: string;
  VendorProgramId: string;
  VendorProgramName: string;
};
export type ReAcquireDealsResponse = {
  isAcquireQuoteApiSuccessful: boolean;
  message: string;
  statusCode: string;
};
export function useReAcquireDeals(params: ReAcquireDealsParams) {
  const buildVars = useBuildVars();
  const apiPost = useApiPost<ReAcquireDealsResponse>({
    host: buildVars.VP_API_BASE,
  });
  return useMutation(() =>
    apiPost(
      `/system.webapi.gds/api/v1/gdsCoreApiExternalApi/GetAcquireQuoteApiDetails`,
      {},
      params
    )
  );
}
